module.exports = __webpack_public_path__ + "4b6cd111eafe42e0cecd5de90f5cd1d7.png";